/**
 * View component for /evaluations/:evaluationId/update
 *
 * Updates a single evaluation from a copy of the selcted evaluation
 * as defined in the evaluation reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as evaluationActions from '../evaluationActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from "../../../global/components/routing/Breadcrumbs.js.jsx";
import Video from "../../../global/components/helpers/Video.js.jsx";
import videoUtils from "../../../global/utils/videoUtils.js";

// import module components
import EvaluationForm from '../components/EvaluationForm.js.jsx';

// import evaluation css modules
import evaluationStyles from '../evaluationModuleStyles.css';

class AdminUpdateEvaluation extends Base {
  constructor(props) {
    super(props);
    const { selectedEvaluation, evaluationMap } = this.props;
    this.state = {
      evaluation: evaluationMap[selectedEvaluation.id] ? _.cloneDeep(evaluationMap[selectedEvaluation.id]) : {}
      // NOTE: we don't want to change the store, just make changes to a copy
      , formHelpers: {
        isNewIntroContent: true
        , isNewPostEvalContent: true
      }
    }
    this._bind(
      '_addTrack'
      , '_deleteTrack'
      , '_handleFormChange'
      , '_handleFormSubmit'
      , '_handleTrackFormChange'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(evaluationActions.fetchSingleIfNeeded(match.params.evaluationId)).then((action) => {
      if(action.success) {
        dispatch(contentModuleActions.fetchSingleIfNeeded(action.item._contentModule));
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    const { selectedEvaluation, evaluationMap } = nextProps;
    this.setState({
      evaluation: evaluationMap[selectedEvaluation.id] ? _.cloneDeep(evaluationMap[selectedEvaluation.id]) : {}
      //we don't want to actually change the store's evaluation, just use a copy
      , formHelpers: {
        isNewIntroContent: true
        , isNewPostEvalContent: true
      }
    })
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    if (e.target.name === "evaluation.introContent") {
      newState.formHelpers.isNewIntroContent = false;
    }
    if (e.target.name === "evaluation.postEvalContent") {
      newState.formHelpers.isNewPostEvalContent = false;
    }
    this.setState(newState);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(evaluationActions.sendUpdateEvaluation(this.state.evaluation)).then((action) => {
      if(action.success) {
        history.push(`/admin/authoring/evaluations/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  _addTrack(videoType) {
    let currentTrackList;
    if(videoType == 'intro') {
      currentTrackList = this.state.evaluation.introTracks
    } else {
      currentTrackList = this.state.evaluation.postTracks
    }
    currentTrackList.push({ file: '', label: '' });
    this._handleFormChange({
      target: {
        name: videoType == 'intro' ? 'evaluation.introTracks' : 'evaluation.postTracks'
        , value: currentTrackList
      }
    });
  }

  _deleteTrack(index, videoType) {
    let nextTrackList;
    if(videoType == 'intro') {
      nextTrackList = this.state.evaluation.introTracks
    } else {
      nextTrackList = this.state.evaluation.postTracks
    }
    nextTrackList.splice(index, 1);
    this._handleFormChange({
      target: {
        name: videoType == 'intro' ? 'evaluation.introTracks' : 'evaluation.postTracks'
        , value: nextTrackList
      }
    });
  }

  _handleTrackFormChange(e, index, videoType) {
    let nextTrackList;
    if(videoType == 'intro') {
      nextTrackList = this.state.evaluation.introTracks
    } else {
      nextTrackList = this.state.evaluation.postTracks
    }
    if(e.name && e.value) {
      nextTrackList[index][e.name] = e.value;
    } else {
      nextTrackList[index][e.target.name] = e.target.value;
    }
    this._handleFormChange({
      target: {
        name: videoType == 'intro' ? 'evaluation.introTracks' : 'evaluation.postTracks'
        , value: nextTrackList
      }
    });
  }

  render() {
    const {
      evaluationMap
      , location
      , match
      , selectedEvaluation
      , contentModuleStore
    } = this.props;
    const { evaluation, formHelpers } = this.state;
    const contentModule = contentModuleStore.selected.getItem();
    const isEmpty = (
      !evaluation
      || evaluation._id === null
      || evaluation._id === undefined
      || !contentModule
    );
    return  (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            {isEmpty ?
              (selectedEvaluation.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <EvaluationForm
                addTrack={this._addTrack}
                cancelLink={`/admin/authoring/evaluations/${evaluation._id}`}
                deleteTrack={this._deleteTrack}
                evaluation={evaluation}
                formHelpers={formHelpers}
                formTitle="Update Evaluation"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                handleTrackFormChange={this._handleTrackFormChange}
                contentModule={contentModule}
              />
            }
          </section>
        </div>
      </AuthoringLayout>
    )
  }
}

AdminUpdateEvaluation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    evaluationMap: store.evaluation.byId
    , evaluationStatuses: store.evaluation.statuses
    , selectedEvaluation: store.evaluation.selected
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminUpdateEvaluation)
);



// WEBPACK FOOTER //
// modules/evaluation/views/AdminUpdateEvaluation.js.jsx